import React, { useState } from "react";
import { Row, Col, Card, Form } from "react-bootstrap";
import {
    FaPhone,
    FaEnvelope,
    FaUserTie,
    FaMapMarkerAlt
} from "react-icons/fa";

import hotelData from "../data/JTDCLOutsourcedUnitsData";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const handleDownloadPDF = () => {
    const doc = new jsPDF();

    let startY = 20;
    let slNo = 1;

    doc.setFontSize(14);
    doc.text("Outsourced Hotels & Properties", 105, 10, { align: "center" });

    const tableData = hotelData.map(item => [
        slNo++,
        item.name,
        item.operator,
        item.mobile,
        item.email,
        item.place
    ]);

    autoTable(doc, {
        startY,
        head: [["SL No", "Hotel Name", "Operator", "Mobile", "Email", "District"]],
        body: tableData,
        didDrawPage: function () {
            startY = 20;
        },
        styles: {
            fontSize: 8,
            cellPadding: 2
        },

        columnStyles: {
            0: { cellWidth: 10 },
            1: { cellWidth: 45 },
            2: { cellWidth: 40 },
            3: { cellWidth: 25 },
            4: { cellWidth: 40 },
            5: { cellWidth: 25 }
        },

        headStyles: {
            fillColor: [220, 220, 220],
            textColor: 0,
            align: "justify",
        },

        theme: "grid",
        margin: { left: 10, right: 10 }
    });

    doc.save("Outsourced_Hotels.pdf");
};

const HotelOutsourced = () => {

    const [place, setPlace] = useState("");

    // Unique places
    const places = [...new Set(hotelData.map(item => item.place))];

    // Filter
    const filteredData = place
        ? hotelData.filter(item => item.place === place)
        : hotelData;

    return (
        <div className="container my-4">

            {/* Heading */}
            <h3 className="mb-4 text-center display-6 display-md-5"
                style={{ fontFamily: '"EB Garamond", serif' }}>
                JTDCL Outsourced Hotels & Properties
            </h3>

            {/* Filter */}
            <Row className="mb-4">
                <Col xs={12} md={4}>
                    <Form.Select
                        value={place}
                        onChange={(e) => setPlace(e.target.value)}
                    >
                        <option value="">All Places</option>
                        {places.map((p, i) => (
                            <option key={i} value={p}>{p}</option>
                        ))}
                    </Form.Select>
                </Col>
            </Row>

            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

                <div className="fw-semibold text-secondary">
                    {place ? (
                        <>
                            Showing <span className="text-primary">{filteredData.length}</span> in{" "}
                            <span className="text-dark">{place}</span>
                        </>
                    ) : (
                        <>
                            Total Properties: <span className="text-primary">{filteredData.length}</span>
                        </>
                    )}
                </div>

                <button
                    className="btn btn-outline-primary"
                    onClick={handleDownloadPDF}
                >
                    Download PDF
                </button>

            </div>

            {/* Cards */}
            <Row className="g-4">
                {filteredData.map((item, index) => (
                    <Col lg={4} md={6} sm={12} key={index}>

                        <Card
                            className="h-100 shadow-sm border-0"
                            style={{ transition: "0.2s ease" }}
                            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-4px)"}
                            onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                        >

                            {/* Image */}
                            <Card.Img
                                variant="top"
                                src={item.image || "/images/default-hotel.jpg"}
                                // onError={(e) => (e.target.src = "/images/default-hotel.jpg")}
                                style={{ height: "200px", objectFit: "cover" }}
                            />

                            <Card.Body className="d-flex flex-column">

                                {/* Title */}
                                <Card.Title className="fw-bold text-secondary mb-2" style={{ fontSize: "1.1rem" }}>
                                    {item.name}
                                </Card.Title>

                                {/* Operator */}
                                <div className="mb-2 d-flex align-items-center gap-2">
                                    <FaUserTie size={13} className="text-secondary" />
                                    <span>{item.operator}</span>
                                </div>

                                {/* Mobile */}
                                <div className="mb-2 d-flex align-items-center gap-2">
                                    <FaPhone size={13} className="text-danger" />
                                    <span>{item.mobile}</span>
                                </div>

                                {/* Email */}
                                <div className="mb-2 d-flex align-items-center gap-2">
                                    <FaEnvelope size={13} className="text-primary" />
                                    <span
                                        className="text-truncate d-inline-block"
                                        style={{ maxWidth: "100%" }}
                                    >
                                        {item.email}
                                    </span>
                                </div>

                                {/* Place */}
                                <div className="mt-auto pt-2 border-top d-flex align-items-center gap-2">
                                    <FaMapMarkerAlt size={13} className="text-success" />
                                    <small>{item.place}</small>
                                </div>

                            </Card.Body>
                        </Card>

                    </Col>
                ))}
            </Row>

        </div>
    );
};

export default HotelOutsourced;